/* =====================================================================
   Amada 详情页改版（方案2）中心化脚本
   fileKey: XaE492jcO59JV3P3DRnROO · 页面「方案2」· 最终稿 153:1026
   约定：只做「稿要求但 CSS 做不到」的事（DOM 文案/位移），不接管主题原有交互。
   ===================================================================== */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 959px)';

  /* ---------------------------------------------------------------
     ① 图库圆点滑窗（稿 153:1070：胶囊只露 8 个 4px 圆点）
     本商品 26 张图 → 主题 JS 仍生成 26 个点（点击/无障碍不变），
     这里把圆点轨道平移，让选中点始终落在 8 格视口内。
     --------------------------------------------------------------- */
  var DOT_WINDOW = 8; // 视口内圆点数（稿）
  var DOT_PITCH = 7; // 圆点节距 = 4px 圆点 + 3px 间距

  function updateDotShift(container) {
    var track = container.querySelector('[data-scroll-slider-page-dots]');
    if (!track) return;

    var dots = track.querySelectorAll('[data-scroll-slider-page-dot]');
    var total = dots.length;

    // 圆点数不超过视口容量时不需要滑窗
    if (total <= DOT_WINDOW) {
      container.style.setProperty('--amada-dot-shift', '0px');
      return;
    }

    var selected = -1;
    for (var i = 0; i < total; i++) {
      if (dots[i].classList.contains('is-selected')) {
        selected = i;
        break;
      }
    }
    if (selected < 0) return;

    // 窗口起点：分组翻页（2026-07-20 用户反馈：旧「选中点固定停第 4 格、轨道平移」
    // 因圆点外观全同，平移不可感知，看起来像白点卡死不动）。
    // 现改为：白点在 8 格窗口内逐格跟随图片前进，走满一组后窗口整体跳到下一组 8 个；
    // 末组不足 8 个时夹紧到最后一整窗（尾部 1-2 张会略微回退一格，属正常）。
    var start = Math.min(Math.floor(selected / DOT_WINDOW) * DOT_WINDOW, total - DOT_WINDOW);
    container.style.setProperty('--amada-dot-shift', start * DOT_PITCH + 'px');
  }

  function initGalleryDots() {
    var containers = document.querySelectorAll('[data-amada-gallery-dots]');
    if (!containers.length) return;

    Array.prototype.forEach.call(containers, function (container) {
      updateDotShift(container);

      // 主题 scroll-slider.js 通过增删 .is-selected 换页，并在断点变化时重建圆点，
      // 两种情况都要跟随 → 同时观察 class 变化与子节点变化。
      var observer = new MutationObserver(function () {
        updateDotShift(container);
      });
      observer.observe(container, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  /* ---------------------------------------------------------------
     ①b PC 主图分页圆点（稿 32:842/32:843，2026-07-28 新增）
     稿：胶囊 rgba(255,255,255,.2)、圆角 23、padding 4/12；圆点 8×8、节距 14；
         选中纯白 / 未选中 白 50%；一次露 8 个（8×8 + 7×6 = 106）。
     ⚠️ 桌面图库不是 scroll-slider —— 主题的 page-dots 组件只服务移动端横滑，
        桌面是「主图 + 缩略图切换」结构，没有现成圆点可用 → 这里按缩略图数量生成，
        选中态跟 `.product-thumbnails__item-link.active` 同步（这是主题标记当前图的方式，
        实测确认；不是 aria-current，也不在 li 上）。
     滑窗算法与移动端同一套「分组翻页」（走满一组 8 个才整体跳窗），
     避免圆点外观全同导致平移不可感知（2026-07-20 已踩过）。
     --------------------------------------------------------------- */
  var PC_DOT_WINDOW = 8;
  var PC_DOT_PITCH = 14; // 8px 圆点 + 6px 间距

  /* ---------------------------------------------------------------
     ①c PC 主图横滑轮播（2026-07-28 运营反馈修复）
     现象：点圆点/缩略图换图时「闪一下白」，而且没有移动端那种滑动感。
     根因两条，都不是 CSS 能盖住的：
       ① 主题桌面图库是「只显示当前一张、其余 .hidden(display:none)」——
          切换是瞬间显隐，本来就没有位移动画；
       ② 26 张主图全是 loading="lazy"，被 display:none 的那张从没加载过，
          切过去时才开始下载 → 先白后出图，就是运营看到的「闪」。
     做法：把所有 media-item 收进一条 flex 轨道（overflow 裁切 + translateX 位移），
     和移动端 scroll-slider 同样的横滑观感；并对「当前 ±1」张提前 eager 预取。
     ⚠️ 主题的 .hidden 仍照常增删（灯箱/变体逻辑读它），只是桌面轨道模式下用 CSS 中和它的
        display:none —— 不去改主题 JS，避免踩到它的媒体切换/变体联动。
     --------------------------------------------------------------- */
  function initDesktopGalleryCarousel() {
    var container = document.querySelector('.product__media-container.above-mobile');
    if (!container) return null;

    /* 2026-08-26 终稿：PC 主图改成「两列拼贴网格」后，横滑轨道整个不需要了
       （所有图已平铺，没有"当前张/下一张"的概念）。
       ⚠️ 必须在这里跳过，不能只靠 CSS —— 本函数会把所有 .product__media-item
       搬进新建的 .amada-gallery-track 里，于是它们**不再是 .product__media 的直接子元素**，
       写在 .product__media 上的 grid 一条都命中不了（实测：12 张图被轨道排成一长行，
       grid 规则全绿但画面全错，正是「选择器没命中」而非「值不对」的典型）。 */
    if (container.hasAttribute('data-amada-collage')) return null;

    var media = container.querySelector('.product__media');
    if (!media) return null;

    var items = [];
    Array.prototype.forEach.call(media.children, function (el) {
      if (el.classList && el.classList.contains('product__media-item')) items.push(el);
    });
    if (items.length < 2) return null;

    var track = document.createElement('div');
    track.className = 'amada-gallery-track';
    media.insertBefore(track, items[0]);
    items.forEach(function (it) {
      track.appendChild(it);
    });
    media.classList.add('amada-gallery-carousel');

    function eager(k) {
      if (k < 0 || k >= items.length) return;
      var img = items[k].querySelector('img');
      // lazy → eager 会让浏览器立刻开始下载；已经 eager/已加载的跳过
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }

    // 邻近优先：切到哪就先把它和左右两张拉起来
    function preload(i) {
      for (var k = i - 2; k <= i + 2; k++) eager(k);
    }

    /* 空闲时分批把**所有**主图预取完。
       只预取邻近不够：从第 26 张跳到第 3 张会横穿中间 20 多张，
       没加载的那些在滑过去的一瞬间就是一片白（运营说的「闪」）。
       分批 + requestIdleCallback，避免和首屏资源抢带宽。 */
    function preloadAllWhenIdle() {
      var next = 0;
      var idle =
        window.requestIdleCallback ||
        function (cb) {
          return window.setTimeout(cb, 200);
        };
      function step() {
        var end = Math.min(next + 3, items.length);
        for (; next < end; next++) eager(next);
        if (next < items.length) idle(step);
      }
      idle(step);
    }

    function go(i) {
      if (i < 0 || i >= items.length) return;
      preload(i); // 先发起加载再位移，别让滑动跑在下载前面
      // 轨道自身宽度 = 容器宽（子项 flex:0 0 100% 溢出不换行）
      // → translateX 的百分比正好是「一屏」，不用 JS 算像素，窗口缩放自动跟随
      track.style.transform = 'translateX(' + -i * 100 + '%)';
    }

    preload(0);
    preloadAllWhenIdle();
    return { go: go, count: items.length };
  }

  function initDesktopGalleryDots() {
    var host = document.querySelector('[data-amada-desktop-dots]');
    if (!host) return;

    var container = host.closest('.product__media-container');
    if (!container) return;

    var carousel = initDesktopGalleryCarousel();

    var thumbLinks = container.querySelectorAll('.product-thumbnails__item-link[data-product-thumbnail]');
    // 只有 1 张图（或缩略图布局关掉了）时不显示圆点
    if (thumbLinks.length < 2) {
      host.hidden = true;
      return;
    }

    var track = document.createElement('div');
    track.className = 'amada-gallery-dots__track';
    var dots = [];
    Array.prototype.forEach.call(thumbLinks, function (link, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'amada-gallery-dots__dot';
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', function () {
        link.click();
      });
      track.appendChild(dot);
      dots.push(dot);
    });

    var viewport = document.createElement('div');
    viewport.className = 'amada-gallery-dots__viewport';
    viewport.appendChild(track);
    host.appendChild(viewport);
    host.removeAttribute('aria-hidden'); // 生成后是可操作控件，不该对读屏隐藏

    /* 选中的缩略图滚进视野。
       26 张竖排、视口只露 6 张 —— 从圆点跳到第 1 张时，缩略图列还停在第 26 张那儿，
       用户既看不到选中框也不知道自己在第几张（2026-07-28 验收实测 scrollTop 停在 2802）。
       ⚠️ 不用 scrollIntoView：它会连带滚动祖先（整页会跳），这里只改 viewport 自己的 scrollTop。
       留 4px 余量，正好等于选中黑框往外扩的那 4px，否则框会贴着视口边缘被切掉。 */
    var EDGE_PAD = 4;
    function revealThumb(i) {
      var vp = container.querySelector('.product-thumbnails__viewport');
      var el = thumbLinks[i];
      if (!vp || !el) return;
      var vr = vp.getBoundingClientRect();
      var er = el.getBoundingClientRect();
      /* 先把元素换算成「内容坐标」再绝对赋值。
         ⚠️ 不要用 `scrollTop -= 差值` 的增量写法：滚动条正在平滑滚动、或图片刚 eager
            加载完改变了布局时，读到的是中间态，增量会算少 —— 实测跳到第 1 张时
            stop 在 58 而不是 0。换算成内容坐标后两边的中间态互相抵消，结果恒定。 */
      var top = er.top - vr.top + vp.scrollTop;
      var bottom = top + er.height;
      if (top - EDGE_PAD < vp.scrollTop) {
        vp.scrollTop = Math.max(0, top - EDGE_PAD);
      } else if (bottom + EDGE_PAD > vp.scrollTop + vp.clientHeight) {
        vp.scrollTop = bottom + EDGE_PAD - vp.clientHeight;
      }
    }

    function sync() {
      var selected = -1;
      for (var i = 0; i < thumbLinks.length; i++) {
        if (thumbLinks[i].classList.contains('active')) {
          selected = i;
          break;
        }
      }
      if (selected < 0) selected = 0;

      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-selected', j === selected);
      }

      // 主图轨道跟着走（缩略图点击、圆点点击、变体切图都收敛到这里）
      if (carousel) carousel.go(selected);
      revealThumb(selected);

      var total = dots.length;
      var shift = 0;
      if (total > PC_DOT_WINDOW) {
        var start = Math.min(
          Math.floor(selected / PC_DOT_WINDOW) * PC_DOT_WINDOW,
          total - PC_DOT_WINDOW
        );
        shift = start * PC_DOT_PITCH;
      }
      host.style.setProperty('--amada-dot-shift', shift + 'px');
    }

    sync();

    // 主题切图时改的是缩略图按钮的 class → 观察缩略图列表即可，
    // 不用监听主图（主图那边靠增删 .hidden，且节点多得多）
    var observer = new MutationObserver(sync);
    Array.prototype.forEach.call(thumbLinks, function (link) {
      observer.observe(link, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------------------------------------------------------------
     ③ 库存行位置：稿 153:1046 要求「In stock」在 ADD TO CART 之下、
        「Shipping calculated at checkout」之上。
     现状 DOM：inventory-counter 在变体上方；而 .product__policies（Shipping…）
     是 buy_buttons block 的**内部**子节点 → 模板 block_order 排不到两者中间；
     且 block_order 移动端/桌面端共用，改它会连带改桌面 → 只能在移动端搬 DOM。
     桌面端保持主题原位（切回宽屏会还原）。
     --------------------------------------------------------------- */
  var inventoryHome = null; // 记录原位，便于切回桌面端还原

  function placeInventoryCounter() {
    var inv = document.querySelector('.inventory-counter');
    var policies = document.querySelector('.product__policies');
    if (!inv) return;

    if (!inventoryHome && inv.parentElement) {
      inventoryHome = { parent: inv.parentElement, next: inv.nextElementSibling };
    }

    if (window.matchMedia(MOBILE_QUERY).matches) {
      // 移动端：移到 Shipping 政策之前（= ADD TO CART 之下）
      if (policies && inv.nextElementSibling !== policies) {
        policies.parentElement.insertBefore(inv, policies);
      }
      return;
    }

    // 桌面端：还原主题原位。
    // ⚠️ 不能用「父节点是否变化」判断——policies 与库存行同属 .product-blocks，
    // 搬运后父节点不变，条件永不成立（曾导致桌面端还原失效）。按相邻节点判断。
    if (inventoryHome && inv.nextElementSibling !== inventoryHome.next) {
      if (inventoryHome.next) {
        inventoryHome.parent.insertBefore(inv, inventoryHome.next);
      } else {
        inventoryHome.parent.appendChild(inv);
      }
    }
  }

  /* ---------------------------------------------------------------
     ④ 评分计数文案：评论 app 输出「(45)」，稿 153:1055 要求「42 reviews」
     app 输出的是纯文本，CSS 改不了词形 → 仅重写文案，不动 app 的链接/挂载点。
     --------------------------------------------------------------- */
  // 记住 app 的原始文案（如「(45)」），桌面端要还原回去，不污染桌面
  var REVIEW_ORIGINAL = 'amadaOriginalCount';

  function syncReviewCount() {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var nodes = document.querySelectorAll('.dd-review .dd-review-count');

    Array.prototype.forEach.call(nodes, function (node) {
      var text = (node.textContent || '').trim();
      if (!text) return;

      // 2026-07-25 需求④：PC 详情页稿（§3.3）同样要求「N reviews」下划线 →
      // 桌面端也改写，但**只改 PDP 右栏**（.product__meta-content 内），
      // 集合页/购物车/快速视图的卡片仍保持 app 原文「(46)」，不做稿外改动。
      var inPdpColumn = !!(node.closest && node.closest('.product__meta-content'));
      var shouldRewrite = isMobile || inPdpColumn;

      if (!shouldRewrite) {
        // 桌面端的稿外位置：还原 app 原文
        var orig = node.dataset[REVIEW_ORIGINAL];
        if (orig && text !== orig) node.textContent = orig;
        return;
      }

      // 已改写过则跳过，避免 MutationObserver 递归
      if (/reviews?$/i.test(text)) return;

      var match = text.match(/(\d[\d,]*)/);
      if (!match) return;

      // 首次见到原文时存档，供桌面端还原
      if (!node.dataset[REVIEW_ORIGINAL]) node.dataset[REVIEW_ORIGINAL] = text;

      var count = match[1];
      var plural = count === '1' ? 'review' : 'reviews';
      node.textContent = count + ' ' + plural;
    });
  }

  function initReviewCount() {
    // ⚠️ 不能在这里用「当前是不是手机宽度」提前 return！
    // 曾经这么写 → 在桌面宽度加载、再把窗口缩到手机的路径下，observer 根本没挂上，
    // 文案永远停在 app 的「(45)」。自动化测试一律直接以 375 加载，这条路径测不出来。
    // 正确做法：监听照挂，宽度判定放到 syncReviewCount 内部，随断点实时生效。
    syncReviewCount();

    // 评论 app 异步渲染，且挂在独立的 shopify-app-block 里（不在商品标题块内），
    // 所以必须观察 document.body。syncReviewCount 幂等，配 rAF 合并避免抖动。
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncReviewCount();
      });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });

    var mq = window.matchMedia(MOBILE_QUERY);
    if (mq.addEventListener) {
      mq.addEventListener('change', syncReviewCount);
    } else if (mq.addListener) {
      mq.addListener(syncReviewCount);
    }
  }

  /* ---------------------------------------------------------------
     ⑤ 券条「Copy Code」点击反馈
     复制本身由行内 onclick="getCode(...)" 完成（沿用主题原函数，含
     sessionStorage.landingCode 写入，勿绕过）。但它的「Copied Successfully」气泡
     长在旧券条 .discounts_code_ms 里，而旧券条在移动端被隐藏 → 点了没反馈。
     稿未画交互态（设计稿默认理想数据），故按主题既有模式补最轻的文案切换，
     已在交付说明中列出待设计师确认。
     --------------------------------------------------------------- */
  var COPIED_TEXT = 'Copied!';
  var COPIED_STORAGE_KEY = 'amadaCouponCopied';

  function initCouponCopy() {
    var btn = document.querySelector('.amada-coupon__copy');
    if (!btn) return;

    var code = btn.getAttribute('data-code') || '';

    // localStorage 按券码永久记住已复制状态（2026-07-21 设计师定：不做时长限制，
    // unique user copy 一次即 forever）；只有运营换新券码（key 对不上）才重置回 Copy Code。
    // 隐私模式下 localStorage 可能抛异常，静默降级为仅本次页面内反馈。
    function readCopied() {
      try {
        return localStorage.getItem(COPIED_STORAGE_KEY) === code;
      } catch (e) {
        return false;
      }
    }
    function saveCopied() {
      try {
        localStorage.setItem(COPIED_STORAGE_KEY, code);
      } catch (e) {
        /* 存不进就只保留本次页面内的 Copied! 文案 */
      }
    }

    if (code && readCopied()) {
      btn.textContent = COPIED_TEXT;
    }

    btn.addEventListener('click', function () {
      btn.textContent = COPIED_TEXT;
      saveCopied();
    });
  }

  /* ---------------------------------------------------------------
     ⑧ PERFECT PAIRINGS（稿 194:3826）：
     - 每张卡片图右上角注入收藏心形（占位链 /pages/wishlist，与图库心形同决策）
     - 价格 "from $xxx" 去掉 "from " 前缀（稿只显示单价）
     宽度判定放函数内部（铁律：监听照挂，判定放函数内部）。
     --------------------------------------------------------------- */
  /* 🔄 2026-09-03 运营验收 Q3/Q4「全站爱心换新素材」：
     这段 SVG 是 snippets/amada-heart-icon.liquid 的**逐字符副本**（那份是唯一源，
     稿 R7BTyfjYZRQKAclDJdkEFD · 191:2051，ink 15.276×13.306；命中盒 191:2048 = 40×40）。
     这里不能 render snippet（JS 运行时注入），改那份 snippet 时**必须同步改这里**。
     未收藏空心 / 已收藏实心由 assets/amada-favorites.css 的 .amada-heart 段控制，
     状态类沿用 .is-favorited。 */
  var PP_HEART_SVG =
    '<svg class="amada-heart amada-pp-wishlist__icon" viewBox="0 0 15.276 13.306" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path class="amada-heart__path" d="M14.058 1.218C13.274 0.434 12.234 0.00200013 11.114 0.00200013C10.002 0.00200013 8.954 0.434 8.17 1.218L7.634 1.754L7.106 1.218C5.482 -0.406 2.842 -0.406 1.218 1.218C-0.406 2.842 -0.406 5.482 1.218 7.106L7.266 13.146C7.362 13.242 7.498 13.306 7.642 13.306C7.786 13.306 7.922 13.25 8.018 13.146L14.058 7.106C15.682 5.482 15.682 2.842 14.058 1.218Z" fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/></svg>';

  function decoratePairingCards() {
    var blk = document.querySelector('.product__block-complementary-products');
    if (!blk) return;

    Array.prototype.forEach.call(
      blk.querySelectorAll('.product-item'),
      function (item) {
        if (!item.querySelector('.amada-pp-wishlist')) {
          var a = document.createElement('a');
          a.href = '/pages/favorites';
          // no-transition：主题 theme.js 的「页面过渡」把所有 a[href] 委托掉——
          // 它自己 preventDefault 后 setTimeout 200ms 跳 href，会盖过收藏脚本的 preventDefault
          // （表现：心形点了确实收藏成功，200ms 后页面还是跳走了）。
          // no-transition 是主题自带的豁免类（购物袋链接同款用法）。
          a.className = 'amada-pp-wishlist no-transition';
          a.setAttribute('aria-label', 'Add to favorites');

          // 从卡片提取商品数据，接通收藏 toggle（amada-favorites.js 委托处理）。
          // handle 从商品链接 /products/<handle> 解析。
          var link = item.querySelector('a[href*="/products/"]');
          var handle = '';
          if (link) {
            var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
            if (m) handle = m[1];
          }
          if (handle) {
            a.setAttribute('data-favorites-toggle', '');
            a.setAttribute('data-product-handle', handle);
            var titleEl = item.querySelector('.product-item__title, .product-item__product-title, [class*="title"]');
            if (titleEl) a.setAttribute('data-product-title', titleEl.textContent.trim());
            var imgEl = item.querySelector('img');
            if (imgEl) a.setAttribute('data-product-image', imgEl.currentSrc || imgEl.src || '');
          }

          a.innerHTML = PP_HEART_SVG;
          item.appendChild(a);
        }

        // 袋盘：从图片内浮动层挪到卡片根（图容器 overflow 裁切，价行位置放不下）
        // 2026-07-25：桌面渲染把它放在 .product-item__list-mode-buttons 里（不是浮动层），
        // 两种父容器都要认，否则 PC 上袋按钮取不到、稿的价行右侧按钮缺失。
        var qaw = item.querySelector(
          '.product-item__floating-action-buttons .product-item__quick-add-wrapper,' +
            '.product-item__list-mode-buttons .product-item__quick-add-wrapper'
        );
        if (qaw) {
          item.appendChild(qaw);
        }
      }
    );

    Array.prototype.forEach.call(
      blk.querySelectorAll('.product-item__price-main'),
      function (main) {
        Array.prototype.forEach.call(main.childNodes, function (node) {
          var isVisuallyHidden =
            node.nodeType === 1 && node.classList.contains('visually-hidden');
          if (isVisuallyHidden) return;
          if (/(^|\s)from\s+\$/i.test(node.textContent)) {
            node.textContent = node.textContent.replace(/(^|\s)from\s+/i, '$1');
          }
        });
      }
    );
  }

  /* ---------------------------------------------------------------
     ⑧-b PERFECT PAIRINGS 卡片右下角购物袋按钮：真正能加购 + 弹购物袋抽屉
         （2026-09-07 运营验收 #33「点击没反应」）
     ---------------------------------------------------------------
     🔍 根因不是「事件没绑上」（这是最容易误判的一类，铁律 18 第二类）：
        1440 草稿实测点击后 /cart.js 的 item_count 0 → 1，**加购其实成功**，
        但页面零反馈 —— 没有购物袋抽屉、没有确认弹窗、连主题唯一的反馈
        （wrapper 加 .active 显出数量步进器）也被 amada-desktop.css 的
        `.product-item__quick-add > * { display:none }` 一起按掉了。
        所以运营看到的是「点了没反应」。

     ✅ 做法（与 assets/amada-search.js 的卡片加购、assets/amada-favorites-ui.js 的
        批量加购完全同一套，不发明第二种）：
          单变体 → 自己 POST /cart/add.js → window.AmadaCartDrawer.open({justAdded:true})
          多变体 → **不接管**，交回主题原生的「选变体」链路
                   （theme.js ProductItem: hasVariants==="true" → r$1('quick-add:open')
                     → quick-product-modal 拉 ?view=quick-add）

     ⚠️ 单变体分支必须掐掉主题那条同名监听（theme.js 是直接绑在按钮上的
        `e$2(quickAddButtons,'click')`），否则一次点击会 **加两件**。
        用 document **捕获阶段** + stopPropagation：捕获在元素监听之前跑，
        事件根本到不了按钮自身的监听（冒泡阶段拦已经晚了）。
     ⚠️ 只接管 `.product__block-complementary-products` 里的按钮 —— 同名类在首页
        推荐位、购物袋 cross-sells 里都有，全站接管会把别处的行为一起改掉。
     ⚠️ 加购中给按钮上 .is-amada-adding（样式在 assets/amada-pdp.css 第 ⑨ 节）
        并锁住 pointer-events，防连点重复下单；fetch 一律带 8s 超时（铁律 31）。
     --------------------------------------------------------------- */
  var PP_QUICK_ADD_SELECTOR = '.product-item__quick-add';
  var PP_BLOCK_SELECTOR = '.product__block-complementary-products';

  /* 与 amada-search.js / amada-favorites-ui.js 同一份实现：
     quick-cart section 导出的 window.AmadaCartDrawer 是唯一真源，
     别再自己轮询 `.quick-cart.is-active` 这类猜出来的开态类名
     （那正是 2026-08-27 audit A-2「加购后被强制跳 /cart」的根因）。 */
  function openCartDrawerFromPairing() {
    if (window.AmadaCartDrawer && typeof window.AmadaCartDrawer.open === 'function') {
      window.AmadaCartDrawer.open({ justAdded: true });
      return;
    }
    // quick-cart 被运营关掉时才该跳整页购物袋
    window.location.href = '/cart';
  }

  function addPairingToCart(btn, variantId) {
    if (typeof fetch !== 'function') return;
    if (btn.classList.contains('is-amada-adding')) return; // 连点保护

    var controller = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 8000);

    btn.classList.remove('is-amada-error');
    btn.classList.add('is-amada-adding');
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return r.json();
      })
      .then(function () {
        openCartDrawerFromPairing();
      })
      .catch(function () {
        /* 失败要看得见：短暂灰掉，别再退回「点了没反应」 */
        btn.classList.add('is-amada-error');
        window.setTimeout(function () {
          btn.classList.remove('is-amada-error');
        }, 2000);
      })
      .finally(function () {
        window.clearTimeout(timer);
        btn.classList.remove('is-amada-adding');
        btn.removeAttribute('aria-busy');
      });
  }

  function initPairingQuickAdd() {
    if (window.__amadaPairingQuickAddBound) return; // 幂等：脚本被引两次也只绑一次
    window.__amadaPairingQuickAddBound = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var btn = e.target.closest(PP_QUICK_ADD_SELECTOR);
        if (!btn || !btn.closest(PP_BLOCK_SELECTOR)) return;

        var wrapper = btn.closest('.product-item__quick-add-wrapper');
        var hasVariants = wrapper && wrapper.getAttribute('data-has-variants') === 'true';
        if (hasVariants) return; // 多变体：放行，走主题原生选变体层

        var variantId = Number(btn.getAttribute('data-variant-id'));
        if (!variantId) return; // 取不到变体就别拦，让主题按老路走

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        addPairingToCart(btn, variantId);
      },
      true /* 捕获阶段：必须抢在主题绑在按钮上的监听之前，否则会加两件 */
    );
  }

  /* ---------------------------------------------------------------
     Shop Pay 分期行：logo 配色对齐稿（稿 153:1177/1178 是**黑色** shop Pay，
     组件默认是品牌紫 #5433EB）。
     该 logo 在 <shopify-payment-terms> 的 shadow DOM 里，页面 CSS 进不去，
     但它的 shadowRoot 是 **open** 的 → 注入一段样式即可（SVG 用 currentColor 上色，
     改父容器 color 就能整体变黑）。
     ⚠️ 只改颜色。文案（"4 interest-free installments…"/"View sample plans"）是
     Shopify 依据后台 Shop Pay Installments 方案生成的**信贷条款披露**，不得用前端改写。
     --------------------------------------------------------------- */
  var SHOP_PAY_STYLE =
    '#shopify-installments .text-purple-primary,' +
    '#shopify-installments [class*="text-purple"] { color: #101010 !important; }';

  function paintShopPayLogo(node) {
    var root = node && node.shadowRoot;
    if (!root || root.querySelector('style[data-amada-shoppay]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-amada-shoppay', '');
    style.textContent = SHOP_PAY_STYLE;
    root.appendChild(style);
  }

  function initShopPayLogo() {
    var nodes = document.querySelectorAll('shopify-payment-terms');
    Array.prototype.forEach.call(nodes, paintShopPayLogo);

    // 组件在变体切换 / 延迟水合时会重建，shadowRoot 出现得比 DOMContentLoaded 晚 → 持续观察
    var observer = new MutationObserver(function () {
      Array.prototype.forEach.call(
        document.querySelectorAll('shopify-payment-terms'),
        paintShopPayLogo
      );
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // shadowRoot 挂载时机不受 body 变动通知 → 前 5 秒轮询兜底
    var tries = 0;
    var timer = setInterval(function () {
      Array.prototype.forEach.call(
        document.querySelectorAll('shopify-payment-terms'),
        paintShopPayLogo
      );
      if (++tries > 10) clearInterval(timer);
    }, 500);
  }

  /* ---------------------------------------------------------------
     手风琴正文里的「Unicode 数学粗体」字符归一化。
     运营录入 Description 时把小标题粘成了 U+1D400 区段的数学粗体字符
     （𝐌𝐨𝐝𝐮𝐥𝐚𝐫 …）而不是 <strong> 标签。这类字符 Inter 里没有字形，
     浏览器会回退到系统衬线体 → 呈现为「又黑又粗的衬线字」，且 CSS 改不动
     （它是字符本身，不是样式）。
     这里把它们等价映射回 ASCII，并包一层 <strong>，使其走稿的
     Inter / 10px / 600 / #787878（其余手风琴无此问题，不受影响）。
     ⚠️ 治标：正确做法是运营改用普通字符 + 加粗，已同步说明。
     --------------------------------------------------------------- */
  var MATH_BOLD_RANGES = [
    // [起点码位, 对应 ASCII 起点, 长度]
    [0x1d400, 65, 26], // 数学粗体 大写
    [0x1d41a, 97, 26], // 数学粗体 小写
    [0x1d7ce, 48, 10], // 数学粗体 数字
    [0x1d5d4, 65, 26], // 无衬线粗体 大写
    [0x1d5ee, 97, 26], // 无衬线粗体 小写
    [0x1d7ec, 48, 10] // 无衬线粗体 数字
  ];

  function mathBoldToAscii(str) {
    var out = '';
    for (var i = 0; i < str.length; ) {
      var cp = str.codePointAt(i);
      var size = cp > 0xffff ? 2 : 1;
      var mapped = null;
      for (var r = 0; r < MATH_BOLD_RANGES.length; r++) {
        var range = MATH_BOLD_RANGES[r];
        if (cp >= range[0] && cp < range[0] + range[2]) {
          mapped = String.fromCharCode(range[1] + (cp - range[0]));
          break;
        }
      }
      out += mapped === null ? str.substr(i, size) : mapped;
      i += size;
    }
    return out;
  }

  var MATH_BOLD_TEST = /[\uD835]/; // 所有相关区段都以该高位代理开头

  function normalizeAccordionBold(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var targets = [];
    var node;
    while ((node = walker.nextNode())) {
      if (MATH_BOLD_TEST.test(node.nodeValue)) targets.push(node);
    }

    targets.forEach(function (textNode) {
      var frag = document.createDocumentFragment();
      // 按「是否数学粗体」切段：粗体段转 ASCII 并包 <strong>，其余原样
      var buf = '';
      var bufIsBold = null;
      var value = textNode.nodeValue;

      function flush() {
        if (buf === '') return;
        if (bufIsBold) {
          var strong = document.createElement('strong');
          strong.textContent = mathBoldToAscii(buf);
          frag.appendChild(strong);
        } else {
          frag.appendChild(document.createTextNode(buf));
        }
        buf = '';
      }

      for (var i = 0; i < value.length; ) {
        var cp = value.codePointAt(i);
        var size = cp > 0xffff ? 2 : 1;
        var chunk = value.substr(i, size);
        var isBold = false;
        for (var r = 0; r < MATH_BOLD_RANGES.length; r++) {
          var range = MATH_BOLD_RANGES[r];
          if (cp >= range[0] && cp < range[0] + range[2]) {
            isBold = true;
            break;
          }
        }
        // 粗体段内的空格并入粗体段，避免标题被拆成多个 <strong>
        if (bufIsBold === true && chunk === ' ') isBold = true;

        if (bufIsBold !== null && isBold !== bufIsBold) flush();
        bufIsBold = isBold;
        buf += chunk;
        i += size;
      }
      flush();

      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  /* 2026-10-05：quick view 抓回 PDP 整页后要按同一口径处理旧手风琴（见 amada-quickview.js
     applyLegacyFallbacks），这里只暴露函数本身，不改 PDP 侧任何行为。 */
  window.AmadaNormalizeMathBold = normalizeAccordionBold;

  function initAccordionBoldNormalize() {
    var blocks = document.querySelectorAll('.product-blocks__accordion .accordion__content');
    Array.prototype.forEach.call(blocks, normalizeAccordionBold);
  }

  /* ---------------------------------------------------------------
     顶部促销条跑马灯（2026-07-20 用户需求）：
     0720 稿字号放大到 16px 后，长文案一行放不下（此前按稿右侧截断，
     优惠码会被切掉）→ 文案超出条宽时自动循环滚动展示全文。
     实现：把文案节点挪进轨道并克隆一份（aria-hidden），CSS 动画平移一段
     文案宽度后无缝续接；不超宽的文案不动。断点/转向变化时重测。
     ⚠️ 含 modal 按钮的公告不做跑马灯（克隆会复制触发器），保持截断。
     --------------------------------------------------------------- */
  var MARQUEE_GAP = 48; // 两段文案首尾间距
  var MARQUEE_SPEED = 40; // px/s，肉眼可读的匀速

  function teardownMarquee(inner) {
    var track = inner.querySelector('.amada-marquee__track');
    if (!track) return;
    var original = track.firstElementChild;
    inner.classList.remove('amada-marquee');
    inner.insertBefore(original, track);
    track.parentNode.removeChild(track);
  }

  function setupMarquee(inner, itemWidth) {
    var text = inner.firstElementChild;
    if (!text) return;
    var track = document.createElement('span');
    track.className = 'amada-marquee__track';
    inner.insertBefore(track, text);
    track.appendChild(text);
    var copy = text.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.removeAttribute('href'); // 克隆段只是视觉填充，避免重复可聚焦链接
    track.appendChild(copy);

    var distance = text.getBoundingClientRect().width + MARQUEE_GAP;
    track.style.setProperty('--amada-marquee-dist', distance + 'px');
    track.style.setProperty('--amada-marquee-duration', distance / MARQUEE_SPEED + 's');
    inner.classList.add('amada-marquee');
  }

  function syncAnnouncementMarquee() {
    var items = document.querySelectorAll('.announcement-bar__item');
    Array.prototype.forEach.call(items, function (item) {
      var itemWidth = item.clientWidth;
      Array.prototype.forEach.call(
        item.querySelectorAll('.announcement-bar__item-inner'),
        function (inner) {
          // 含 modal 触发按钮的公告不做（克隆会复制交互元素）
          if (inner.querySelector('.announcement-bar__details-link')) return;

          var active = inner.classList.contains('amada-marquee');
          // 先还原再量，避免用跑马灯态的宽度误判
          if (active) teardownMarquee(inner);
          var text = inner.firstElementChild;
          if (!text || itemWidth <= 0) return;
          if (text.getBoundingClientRect().width > itemWidth + 1) {
            setupMarquee(inner, itemWidth);
          }
        }
      );
    });
  }

  function initAnnouncementMarquee() {
    syncAnnouncementMarquee();
    var timer = null;
    window.addEventListener('resize', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(syncAnnouncementMarquee, 150);
    });
  }

  /* 配送第二行「Arrives <月 日>–<月 日>」按访客本地日期更新（0721.v2 稿 306:1541）。
     Liquid 已出服务端初值（无 JS 也正确、不闪烁），但 Shopify CDN 会缓存整页 HTML，
     只靠 Liquid 的日期会随缓存过期停在旧日期 → 客户端按本地时间重算覆盖。
     规则：今天 +7 ~ +14（稿示例 7/21 当天画的是「Jul 28–Aug 4」，正好 +7/+14）。
     跨月写两个月份（Jul 28–Aug 4），同月省略第二个月份（Jul 28–31，标准英文写法；
     稿只给了跨月example，同月写法已列交付说明待设计师确认）。 */
  function initArrivalDate() {
    var el = document.querySelector('[data-amada-arrival]');
    if (!el) return;

    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var now = new Date();
    var from = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7);
    var to = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 14);

    var fromTxt = MONTHS[from.getMonth()] + ' ' + from.getDate();
    var toTxt = from.getMonth() === to.getMonth()
      ? String(to.getDate())
      : MONTHS[to.getMonth()] + ' ' + to.getDate();

    // 稿用的是 en dash（–），不是连字符。
    // 日期段单独包一层 .amada-delivery__date 加下划线（2026-07-21 用户要求，
    // 与信任行 Contact Us 同款：1px / offset 3.2px）；「Arrives」不带下划线。
    // 用 DOM 构造而非 innerHTML，避免把文本当 HTML 解析。
    el.textContent = 'Arrives ';
    var dateEl = document.createElement('span');
    dateEl.className = 'amada-delivery__date';
    dateEl.textContent = fromTxt + '–' + toTxt;
    el.appendChild(dateEl);
  }

  /* ==========================================================================
     PDP 拼贴主图「放大按钮」——2026-08-26 按原型注释重做
     ==========================================================================
     设计师在原型（Sites 文件 9Q97rO6DhvL6lOGDJwxdZt）里写的原话：
       「鼠标悬停时，出现」「点击放大按钮为全屏展示，再次点击恢复原来状态」
     → 三条改动（**只作用于 PC 拼贴态**，移动端一行不动）：
       ① hover 主图区才出现按钮（纯 CSS，见 assets/amada-pdp.css）
       ② 点按钮 → 整块拼贴图库占满视口（全屏展示）
       ③ 再点同一颗按钮 / ESC → 恢复原状
     ⚠️ 原有行为是「点按钮 → 开 PhotoSwipe 灯箱」，那段委托写在
        sections/main-product--default.liquid 里（冒泡阶段，document 上）。
        本函数注册在**捕获阶段**并 stopPropagation，抢在它前面接管；
        非拼贴态 / 移动端不拦截，旧灯箱行为原样保留（铁律：只在该断点生效的
        差异才收进条件里，语义规则放全局）。
     ⚠️ 「全屏展示」的**具体形态稿里没画**（原型只有一句话），本实现取
        「整块拼贴图库占满视口、可纵向滚动」这一最直白的读法，已在
        figma-qa/reports/amada-pdp-phase2.md 列为待运营确认项。
     图标：稿 4:10937 / 55:18520 是 30×30 白底方块 + 四角外扩箭头，
     主题模板里 render 的是 gallery-cube（弧形立方体），形状对不上（铁律 5）。
     模板文件不在本轮可改范围 → 由本函数在拼贴态把按钮内容换成稿的矢量，
     fill 落到 path 上并用 currentColor（铁律 14）。
     ========================================================================== */
  var ZOOM_ICON_SVG =
    '<svg class="amada-gallery-zoom__icon" width="16" height="16" viewBox="7 7 16 16" fill="none" ' +
    'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M7.41443 15.4429C7.64 15.4534 7.82623 15.2721 7.82623 15.0486V8.65599C7.82623 8.18022 8.20918 7.79645 8.68393 7.79645H15.0131C15.2361 7.79645 15.417 7.60982 15.4066 7.38377C15.3961 7.17086 15.2125 7.00789 15 7.00789H7.89705C7.42229 7.00789 7.03934 7.39165 7.03934 7.86742V15.0381C7.03934 15.251 7.20459 15.435 7.41443 15.4429ZM22.5698 14.6018C22.3574 14.6123 22.1947 14.7963 22.1947 15.0092V21.3335C22.1947 21.8093 21.8118 22.193 21.337 22.193H15C14.7875 22.193 14.6039 22.356 14.5934 22.5689C14.5829 22.795 14.7639 22.9816 14.9869 22.9816H22.1213C22.5961 22.9816 22.979 22.5978 22.979 22.1221V14.9961C22.979 14.7726 22.7954 14.5939 22.5698 14.6018ZM12.4636 22.2088H8.31147L12.7128 17.7981C12.8675 17.643 12.8675 17.3933 12.7128 17.2408C12.6367 17.1646 12.5344 17.1252 12.4347 17.1252C12.3351 17.1252 12.2328 17.1646 12.1567 17.2408L7.78688 21.62V17.5247C7.78688 17.3066 7.61115 17.1304 7.39344 17.1304C7.17574 17.1304 7 17.3066 7 17.5247V22.0721C7 22.5847 7.41443 23 7.9259 23H12.4636C12.6813 23 12.857 22.8239 12.857 22.6057C12.857 22.3875 12.6787 22.2088 12.4636 22.2088ZM22.0767 7H17.539C17.3213 7 17.1456 7.17611 17.1456 7.39428C17.1456 7.61245 17.3213 7.78857 17.539 7.78857H21.6623L17.2741 12.1861C17.1193 12.3412 17.1193 12.5909 17.2741 12.7434C17.4288 12.8985 17.678 12.8985 17.8302 12.7434L22.2131 8.35108V12.4753C22.2131 12.6934 22.3888 12.8696 22.6065 12.8696C22.8243 12.8696 23 12.6934 23 12.4753V7.92788C23.0026 7.41531 22.5856 7 22.0767 7Z"/>' +
    '</svg>';

  var FULL_CLASS = 'is-amada-gallery-full';

  /** 该按钮是不是「PC 拼贴态」的那颗（只有它改行为，其余保持旧灯箱） */
  function collageZoomContainer(btn) {
    if (!btn) return null;
    if (!window.matchMedia('(min-width: 960px)').matches) return null;
    var container = btn.closest('.product__media-container.above-mobile[data-amada-collage]');
    return container || null;
  }

  /* 🚨 必须把容器搬到 <body> 下才能真的盖住全屏 —— 实测踩坑：
     图库的祖先 .product__primary-left 是 position:sticky，**sticky 元素必定新建
     层叠上下文**，于是里面写多大的 z-index 都被关在这个上下文里，
     促销条（.announcement-bar，position:relative）和 header（sticky z=510）
     照样画在它上面。表现是「全屏了但顶部 100px 被促销条+导航压着，
     右上角的退出按钮点不到」——elementFromPoint 命中的是 announcement-bar。
     所以进全屏时把容器 appendChild 到 body（留一个占位注释节点记住原位置），
     退出时原样放回去。 */
  function exitGalleryFullscreen(container) {
    if (!container) return;
    container.classList.remove(FULL_CLASS);
    document.documentElement.classList.remove('amada-gallery-full-open');
    var ph = container.__amadaFullPlaceholder;
    if (ph && ph.parentNode) {
      ph.parentNode.insertBefore(container, ph);
      ph.parentNode.removeChild(ph);
    }
    container.__amadaFullPlaceholder = null;
    var btn = container.querySelector('[data-amada-gallery-zoom]');
    if (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Zoom image');
    }
    if (container.__amadaFullScrollY != null) {
      window.scrollTo(0, container.__amadaFullScrollY);
      container.__amadaFullScrollY = null;
    }
  }

  function enterGalleryFullscreen(container) {
    if (!container) return;
    container.__amadaFullScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ph = document.createComment('amada-gallery-fullscreen-placeholder');
    container.parentNode.insertBefore(ph, container);
    container.__amadaFullPlaceholder = ph;
    document.body.appendChild(container);
    container.classList.add(FULL_CLASS);
    document.documentElement.classList.add('amada-gallery-full-open');
    container.scrollTop = 0;
    var btn = container.querySelector('[data-amada-gallery-zoom]');
    if (btn) {
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Exit full screen');
    }
  }

  function initCollageZoom() {
    // 图标替换：拼贴态的那颗按钮换成稿的四角外扩箭头
    var buttons = document.querySelectorAll(
      '.product__media-container.above-mobile[data-amada-collage] [data-amada-gallery-zoom]'
    );
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.getAttribute('data-amada-zoom-icon') === 'figma') return;
      btn.innerHTML = ZOOM_ICON_SVG;
      btn.setAttribute('data-amada-zoom-icon', 'figma');
      btn.setAttribute('aria-pressed', 'false');
    });

    // 捕获阶段接管点击，抢在 main-product--default.liquid 那段冒泡委托（开灯箱）之前
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest && event.target.closest('[data-amada-gallery-zoom]');
        if (!btn) return;
        var container = collageZoomContainer(btn);
        if (!container) return; // 移动端 / 非拼贴态：不拦截，走旧灯箱
        event.preventDefault();
        event.stopPropagation();
        if (container.classList.contains(FULL_CLASS)) {
          exitGalleryFullscreen(container);
        } else {
          enterGalleryFullscreen(container);
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      var open = document.querySelector('.' + FULL_CLASS);
      if (open) exitGalleryFullscreen(open);
    });

    // 缩窄到移动端时全屏态没有意义，直接退出（铁律 23：桌面→缩窄→再放大也要正确）
    var mq = window.matchMedia('(min-width: 960px)');
    var onChange = function () {
      if (mq.matches) return;
      var open = document.querySelector('.' + FULL_CLASS);
      if (open) exitGalleryFullscreen(open);
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function init() {
    initArrivalDate();
    initGalleryDots();
    initDesktopGalleryDots();
    initAnnouncementMarquee();
    placeInventoryCounter();
    initReviewCount();
    initCouponCopy();
    decoratePairingCards();
    initPairingQuickAdd();
    initShopPayLogo();
    initAccordionBoldNormalize();
    initCollageZoom();

    // 断点切换时重新判定库存行归属（移动端搬运 / 桌面端还原）
    var mq = window.matchMedia(MOBILE_QUERY);
    if (mq.addEventListener) {
      mq.addEventListener('change', placeInventoryCounter);
    } else if (mq.addListener) {
      mq.addListener(placeInventoryCounter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
